import { render, staticRenderFns } from "./PaymentMethodsControl.vue?vue&type=template&id=6e40a10b&scoped=true"
import script from "./PaymentMethodsControl.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e40a10b",
  null
  
)

export default component.exports